import React__default, { useCallback, useEffect } from 'react';
import { PROGRESS_STEP, PROGRESS_INTERVAL_MS, END_PROGRESS_PERCENTAGE } from '../../constants.js';
import ProgressBar from './ProgressBar.js';

/* eslint-disable @typescript-eslint/no-explicit-any */
const ProgressBarContainer = ({ endPercentage = END_PROGRESS_PERCENTAGE, progressConfig, setProgress, className }) => {
    const frame = useCallback(() => {
        setProgress(({ progress, intervalId }) => {
            if (progress >= endPercentage) {
                clearInterval(intervalId);
                return {
                    intervalId,
                    progress
                };
            }
            return {
                intervalId,
                progress: progress + PROGRESS_STEP
            };
        });
    }, [endPercentage, setProgress]);
    useEffect(() => {
        const id = setInterval(frame, PROGRESS_INTERVAL_MS);
        setProgress((prevProgressConfig) => ({
            intervalId: id,
            progress: prevProgressConfig.progress
        }));
        return () => {
            clearInterval(id);
        };
    }, [frame, setProgress]);
    return React__default.createElement(ProgressBar, { className: className, progress: progressConfig.progress });
};

export { ProgressBarContainer as default };
//# sourceMappingURL=ProgressBarContainer.js.map
